import { useQueryClient } from '@tanstack/react-query';
import { http } from 'services/http';
import { CONTACTS_GET_MANY } from 'api/query-keys.ts';
import type { ContactRes, UpdateContactReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';
import type { WithPagination } from 'shared/utils/pagination.ts';

type THandleSuccessFn = (data: ContactRes) => void;

interface IUpdateContactMutationOptions {
  handleSuccess?: THandleSuccessFn;
}

export const useUpdateContact = (contactId: number, options?: IUpdateContactMutationOptions) => {
  const queryClient = useQueryClient();

  return useMutationBase<ContactRes, unknown, UpdateContactReq>({
    mutationFn: async (variables) => {
      const res = await http.patch<ContactRes>(`/v1/contacts/${contactId}`, variables);

      return res.data;
    },

    onSuccess: (result) => {
      if (options?.handleSuccess) options.handleSuccess(result);

      const contactsData = queryClient.getQueryData<WithPagination<ContactRes[]>>([
        CONTACTS_GET_MANY,
        result.clientId,
      ]) || { data: [], pagination: null };

      queryClient.setQueryData([CONTACTS_GET_MANY, result.clientId], {
        ...contactsData,
        data: contactsData.data.map<ContactRes>((contact) => {
          if (contact.id === result.id) return result;
          return contact;
        }),
      });
    },
  });
};
